<template>
  <v-alert icon="mdi-shield-lock-outline" prominent text type="info">
    <v-row align="center">
      <v-col class="grow">
        Enter your Master Password to decrypt your data
      </v-col>
      <v-col class="shrink">
        <v-btn color="info" @click="clickSubmitMasterPassword">let's go</v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>
export default {
  name: "EncryptionAlert",
  methods: {
    clickSubmitMasterPassword() {
      this.$store.dispatch("fullscreenFormMode", {
        mode: "master_password",
      });
    },
  },
};
</script>
